import { Center, Loader } from '@mantine/core';
import DynamicPage from 'src/UI/dynamicUI/DynamicPage';
import { UpsertEntityInput, useUpsertEntity } from '../data-capture/merge-review/useUpsertEntities';
import { GenericErrorPage } from '../error/GenericErrorPage';
import useDynamicNonFinancialData from './hooks/useDynamicNonFinancialData';
import { notifyAndLogError } from 'src/UI/common/ui-helpers';

export default function DynamicNonFinancialDataFields() {
  const {
    isLoading,
    isError,
    nonFinancialData,
    refetch: refetchEntities,
  } = useDynamicNonFinancialData();
  const { upsertEntities } = useUpsertEntity();

  const upsertEntitiesAndReload = async (
    clientId: string | undefined,
    entitiesToUpsert: UpsertEntityInput[],
  ) => {
    try {
      if (!clientId) {
        return;
      }
      await upsertEntities(clientId, entitiesToUpsert, false);
      await refetchEntities();
    } catch (e) {
      notifyAndLogError(
        'Failed to save changes',
        'Something went wrong while saving your changes. Please refresh the page and try again. If the issue persists, please contact support',
        e,
        { entitiesToUpsert },
      );
    }
  };

  if (isLoading) {
    return (
      <Center>
        <Loader />
      </Center>
    );
  }

  if (isError || !nonFinancialData) {
    return <GenericErrorPage error={{ isError, nonFinancialData }} />;
  }

  return <DynamicPage uiData={nonFinancialData} onSubmit={upsertEntitiesAndReload} />;
}
